/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { deliverySlotSchema } from "./deliverySlotSchema.ts";

export const deliverySlotsResponseSchema = z.object({
	date: z.iso.date(),
	duration_minutes: z.int(),
	asap_available: z.boolean(),
	slots: z.array(deliverySlotSchema),
});
